import type { Element } from './enums';

export type SketchModelId = string;

/**
 * Character sketch slots. 2 slots maximum, with per-element anti-duplicate
 * enforced on the equipped loadout (see `SketchService`).
 */
export type SketchSlotName = 'sketch1' | 'sketch2';

export const SKETCH_SLOT_NAMES: readonly SketchSlotName[] = [
  'sketch1',
  'sketch2',
] as const;

/**
 * Static definition of a "croquis" (dream drawing). Confers a defensive
 * emotion-type when equipped; resistances/weaknesses come from the fixed
 * effectiveness chart (cf. data/emotions.config.ts), not raw resistance values.
 *
 * Sketches are drops only — no forge, no tier system.
 */
export interface SketchDefinition {
  id: SketchModelId;
  name: string;
  icon?: string;
  /** Defensive emotion-type this drawing confers when equipped. */
  emotion: Element;
  sellValue: number;
}
